export default __webpack_public_path__ + "static/media/Path 91.77a12cfb.svg";